import React, { useState, useEffect } from 'react';
import './LotusGreensModal.css';

const amenities = [
  { icon: '🏰', text: 'Gated Society with Boundary Walls' },
  { icon: '🚰', text: 'Complete Sewerage System' },
  { icon: '💧', text: 'Proper Water Drainage System' },
  { icon: '🚇', text: 'Metro Connectivity' },
  { icon: '💡', text: 'Street Lights Throughout' },
  { icon: '🛣️', text: 'Open & Wide Roads (25ft)' },
  { icon: '🧭', text: 'Vastu Compliant Design' },
  { icon: '🛕', text: 'Temple & Residential Surroundings' },
  { icon: '🏫', text: 'Schools & Shopping Complex Nearby' },
  { icon: '🌿', text: 'Lawn & Green Spaces' },
  { icon: '🏊', text: 'Expandable Living Area' },
  { icon: '🔒', text: 'Covered Boundary Security' },
];

const floorPlans = [
  {
    type: '116 Sq. Yd.',
    config: '3 BHK',
    color: '#1B6B2E',
    features: ['3 Bedrooms', '3 Toilets', 'Modular Kitchen', 'Family Lounge', 'Drawing Room', 'Balcony', 'Expandable Area', 'Terrace Garden with Washroom'],
    rooms: [
      { name: 'Bedroom 1', size: "15'9\" × 13'9\"", bg: '#E8F5E9' },
      { name: 'Bedroom 2', size: "15'9\" × 13'9\"", bg: '#E8F5E9' },
      { name: 'Bedroom 3', size: "13'10\" × 14'7\"", bg: '#E8F5E9' },
      { name: 'Living + Dining', size: "15'1\" × 12'1\"", bg: '#FFF3E0' },
      { name: 'Kitchen', size: "13'10\" × 10'3\"", bg: '#E3F2FD' },
      { name: 'Family Lounge', size: "15'1\" × 12'1\"", bg: '#F3E5F5' },
      { name: 'Parking', size: "10'0\" × 15'0\"", bg: '#ECEFF1' },
      { name: 'Terrace', size: 'Top Floor', bg: '#FFF9C4' },
    ],
  },
  {
    type: '100 Sq. Yd.',
    config: '3 BHK',
    color: '#1558A0',
    features: ['3 Bedrooms', '3 Toilets', 'Modular Kitchen', 'Family Lounge', 'Drawing Room', 'Balcony', 'Expandable Area', 'Terrace Garden with Washroom'],
    rooms: [
      { name: 'Bedroom 1', size: "12'9\" × 13'9\"", bg: '#E8F5E9' },
      { name: 'Bedroom 2', size: "12'9\" × 13'9\"", bg: '#E8F5E9' },
      { name: 'Bedroom 3', size: "12'0\" × 14'7\"", bg: '#E8F5E9' },
      { name: 'Living + Dining', size: "11'7\" × 12'1\"", bg: '#FFF3E0' },
      { name: 'Kitchen', size: "12'0\" × 9'0\"", bg: '#E3F2FD' },
      { name: 'Family Lounge', size: "11'7\" × 12'1\"", bg: '#F3E5F5' },
      { name: 'Parking', size: "8'3\" × 16'0\"", bg: '#ECEFF1' },
      { name: 'Terrace', size: 'Top Floor', bg: '#FFF9C4' },
    ],
  },
];

const locationPoints = [
  { time: '10 min', place: 'Gaur City Mall' },
  { time: '15 min', place: 'Crossing Republic, NH-24' },
  { time: '20 min', place: 'Sector-52, Noida Metro Station' },
  { time: '20 min', place: 'Ghaziabad Railway Station' },
  { time: '30 min', place: 'Noida, Sector-18' },
  { time: '35 min', place: 'Kalindi Kunj' },
  { time: 'Near', place: 'IT Hub & Knowledge Park V' },
];

const specifications = [
  { icon: '⚡', title: 'Electrical Work', desc: 'Wire – KEI/Polycab/Havells. Electrical PVC pipe – AKG/Jindal.' },
  { icon: '🪵', title: 'Tiles', desc: 'Kajaria, Somany & AGL tiles throughout the property.' },
  { icon: '🎨', title: 'Paint', desc: 'Asian/Nerolac with False Ceiling in all major rooms.' },
  { icon: '🚪', title: 'Door & Window', desc: 'MS Frames/G.I. Hardwood laminated Internal/External doors with MICA finish.' },
  { icon: '🍳', title: 'Kitchen', desc: 'Modular Sleek kitchen by Prestige. Premium countertops.' },
  { icon: '🚿', title: 'Sanitary Fittings', desc: 'PVC Pipe – Tirupati/Kissan/Supreme (11kg). CPVC – Supreme/Prince.' },
  { icon: '💧', title: 'Submersible', desc: 'ISI Marked Branded Motor. PVC Pipe – Tirupati/Kissan (11kg weight).' },
  { icon: '🛁', title: 'Bathroom Fittings', desc: 'Hindware, Kohler, Jaguar, AGL – premium bathroom fittings.' },
  { icon: '🪟', title: 'Other Features', desc: 'Toughened glass in staircase and balcony. SS railings in staircase and balcony.' },
];

const tabs = ['Overview', 'Amenities', 'Floor Plans', 'Location', 'Specifications'];

export default function LotusGreensModal({ onClose }) {
  const [activeTab, setActiveTab] = useState('Overview');
  const [activePlan, setActivePlan] = useState(0);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = ''; };
  }, []);

  useEffect(() => {
    const handler = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [onClose]);

  return (
    <div className="lg-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="lg-modal">

        {/* ── HERO ── */}
        <div className="lg-hero">
          <img src="/image/loutusgreenvilla.png" alt="Lotus Greens Villa 2" className="lg-hero-img" />
          <div className="lg-hero-overlay" />
          <button className="lg-close" onClick={onClose} aria-label="Close">
            <i className="fa fa-times" />
          </button>
          <div className="lg-hero-content">
            <div className="lg-badge">Own Your Luxury</div>
            <h1>Lotus Greens Villa 2</h1>
            <p className="lg-tagline">3 & 4 BHK Luxurious Smart Villas · Vaidpura, Greater Noida West</p>
            <div className="lg-hero-tags">
              <span><i className="fa fa-check-circle" /> Vastu Compliant</span>
              <span><i className="fa fa-map-marker-alt" /> Greater Noida West</span>
              <span><i className="fa fa-home" /> 3 & 4 BHK Villas</span>
              <span><i className="fa fa-road" /> 25ft Wide Roads</span>
            </div>
          </div>
        </div>

        {/* ── TABS ── */}
        <div className="lg-tabs">
          {tabs.map(tab => (
            <button
              key={tab}
              className={`lg-tab ${activeTab === tab ? 'active' : ''}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>

        {/* ── CONTENT ── */}
        <div className="lg-body">

          {/* OVERVIEW */}
          {activeTab === 'Overview' && (
            <div className="lg-section">
              <div className="lg-overview-grid">
                <div className="lg-overview-text">
                  <div className="lg-gold-tag">A Right Choice for Your Big Dreams</div>
                  <h2>Stunning Day & Night Views</h2>
                  <p>
                    <strong>Lotus Greens Luxury Villa 2</strong> are located in the prime location of
                    Greater Noida West. These residential Villas have excellent connectivity, medical
                    facility, shopping centre and schools.
                  </p>
                  <p>
                    Each villa has been carefully designed to allow superior ventilation and spectacular
                    landscape. Demand for Luxury Villas in the country is rising & attracts investors
                    and high-worth individuals.
                  </p>
                  <p>
                    These villas are coveted space offering location benefits, <strong>large living spaces</strong>
                    &nbsp;and access to world-class amenities alongside complete privacy.
                  </p>
                  <div className="lg-highlights">
                    <div className="lg-highlight-item">
                      <span className="lg-hl-num">3&4</span>
                      <span className="lg-hl-label">BHK Villas</span>
                    </div>
                    <div className="lg-highlight-item">
                      <span className="lg-hl-num">116</span>
                      <span className="lg-hl-label">Sq. Yd. Max</span>
                    </div>
                    <div className="lg-highlight-item">
                      <span className="lg-hl-num">25ft</span>
                      <span className="lg-hl-label">Wide Roads</span>
                    </div>
                    <div className="lg-highlight-item">
                      <span className="lg-hl-num">G+2</span>
                      <span className="lg-hl-label">Floors</span>
                    </div>
                  </div>
                </div>
                <div className="lg-overview-img">
                  <img src="/image/loutusgreenvilla.png" alt="Lotus Greens Villa" />
                  <div className="lg-night-tag">
                    <span>✨ Stunning Night Views</span>
                  </div>
                </div>
              </div>

              <div className="lg-lifestyle-section">
                <h3>🌿 Lifestyle</h3>
                <p>
                  These luxury villas are tucked away in the quiet city outskirts which is one of the
                  finest residential areas to live in. Whenever you are opting for an attractive
                  environment & luxury lifestyle, Lotus Greens Villa 2 ensures you make the right choice.
                </p>
              </div>
            </div>
          )}

          {/* AMENITIES */}
          {activeTab === 'Amenities' && (
            <div className="lg-section">
              <h2>Facilities & Amenities</h2>
              <p className="lg-section-sub">Everything you need for a complete, modern lifestyle.</p>
              <div className="lg-amenities-grid">
                {amenities.map((a, i) => (
                  <div className="lg-amenity-card" key={i}>
                    <div className="lg-amenity-icon">{a.icon}</div>
                    <span>{a.text}</span>
                  </div>
                ))}
              </div>

              <div className="lg-brands-section">
                <h3>Premium Brands Used</h3>
                <div className="lg-brands">
                  {['Godrej', 'Anchor (Panasonic)', 'Jaquar', 'Hindware', 'Kajaria', 'Polycab', 'Havells', 'Asian Paints', 'Nerolac', 'Somany', 'Kohler', 'Supreme'].map(b => (
                    <div className="lg-brand-chip" key={b}>{b}</div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* FLOOR PLANS */}
          {activeTab === 'Floor Plans' && (
            <div className="lg-section">
              <h2>Villa Floor Plans</h2>
              <p className="lg-section-sub">Two premium plot sizes — choose what fits your vision</p>

              <div className="lg-plan-tabs">
                {floorPlans.map((plan, i) => (
                  <button
                    key={i}
                    className={`lg-plan-tab ${activePlan === i ? 'active' : ''}`}
                    style={activePlan === i ? { background: plan.color, borderColor: plan.color } : {}}
                    onClick={() => setActivePlan(i)}
                  >
                    {plan.config} — {plan.type}
                  </button>
                ))}
              </div>

              <div className="lg-plan-content">
                <div className="lg-plan-info" style={{ borderTop: `4px solid ${floorPlans[activePlan].color}` }}>
                  <div className="lg-plan-header">
                    <h3>{floorPlans[activePlan].config} Villa</h3>
                    <span className="lg-plan-badge" style={{ background: floorPlans[activePlan].color }}>
                      {floorPlans[activePlan].type}
                    </span>
                  </div>
                  <div className="lg-plan-features">
                    {floorPlans[activePlan].features.map((f, i) => (
                      <div className="lg-plan-feature" key={i}>
                        <i className="fa fa-check" style={{ color: floorPlans[activePlan].color }} />
                        <span>{f}</span>
                      </div>
                    ))}
                  </div>
                  <div className="lg-plan-floors">
                    <div className="lg-floor-chip">Ground Floor</div>
                    <div className="lg-floor-chip">First Floor</div>
                    <div className="lg-floor-chip">Terrace Floor</div>
                  </div>
                  <button className="lg-enquire-btn" style={{ background: floorPlans[activePlan].color }}>
                    <i className="fa fa-phone" /> Enquire About This Plan
                  </button>
                </div>

                <div className="lg-plan-visual">
                  <div className="lg-floor-diagram">
                    <div className="lg-floor-label">Floor Layout</div>
                    <div className="lg-floor-rooms">
                      {floorPlans[activePlan].rooms.map((r, i) => (
                        <div className="lg-room" key={i} style={{ background: r.bg }}>
                          {r.name}<br /><small>{r.size}</small>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* LOCATION */}
          {activeTab === 'Location' && (
            <div className="lg-section">
              <h2>Well Connected Location</h2>
              <p className="lg-section-sub">Sector-10, Vaidpura, Greater Noida West, U.P. — strategically connected to all essentials</p>

              <div className="lg-location-grid">
                <div className="lg-location-list">
                  <h3><i className="fa fa-map-marker-alt" /> Distance Advantage</h3>
                  {locationPoints.map((l, i) => (
                    <div className="lg-loc-item" key={i}>
                      <div className="lg-loc-time" style={{ background: '#1B6B2E' }}>{l.time}</div>
                      <div className="lg-loc-place">{l.place}</div>
                    </div>
                  ))}
                </div>

                <div className="lg-nearby">
                  <div className="lg-nearby-group">
                    <h3><i className="fa fa-graduation-cap" /> Schools Nearby</h3>
                    <ul>
                      <li>Shri Ram Global School</li>
                      <li>BGS Vijnatham School</li>
                      <li>Indus Valley Public School</li>
                      <li>Florence International School</li>
                    </ul>
                  </div>
                  <div className="lg-nearby-group">
                    <h3><i className="fa fa-shopping-bag" /> Shopping & Malls</h3>
                    <ul>
                      <li>Galaxy Diamond Plaza</li>
                      <li>Gaur City Mall</li>
                      <li>PKS Town Central</li>
                      <li>DLF Mall of India</li>
                    </ul>
                  </div>
                  <div className="lg-nearby-group">
                    <h3><i className="fa fa-hospital" /> Hospitals</h3>
                    <ul>
                      <li>Numed Super Speciality Hospital</li>
                      <li>LYF Hospital</li>
                      <li>Yatharth Super Speciality Hospital</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="lg-map-embed">
                <iframe
                  title="Lotus Greens Location"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3503.2!2d77.4621!3d28.6289!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce5a43173357b%3A0x37ffce30c87cc03f!2sGreater%20Noida%20West!5e0!3m2!1sen!2sin!4v1699999999999"
                  width="100%" height="220"
                  style={{ border: 0, borderRadius: 12 }}
                  allowFullScreen="" loading="lazy"
                />
                <div className="lg-site-office">
                  <i className="fa fa-building" />
                  <span><strong>Site Office:</strong> Lotus Greens Villa 2, Sector-10, Vaidpura, Greater Noida West, U.P.</span>
                </div>
              </div>
            </div>
          )}

          {/* SPECIFICATIONS */}
          {activeTab === 'Specifications' && (
            <div className="lg-section">
              <h2>Premium Specifications</h2>
              <p className="lg-section-sub">Every detail crafted with the finest materials for lasting quality</p>
              <div className="lg-specs-grid">
                {specifications.map((s, i) => (
                  <div className="lg-spec-card" key={i}>
                    <div className="lg-spec-icon">{s.icon}</div>
                    <div>
                      <h4>{s.title}</h4>
                      <p>{s.desc}</p>
                    </div>
                  </div>
                ))}
              </div>

              <div className="lg-contact-bar">
                <div className="lg-contact-info">
                  <i className="fa fa-map-marker-alt" />
                  <div>
                    <strong>Lotus Greens Villa 2</strong>
                    <span>Sector-10, Vaidpura, Greater Noida West, U.P.</span>
                  </div>
                </div>
                <button className="lg-enquire-btn green">
                  <i className="fa fa-phone" /> Book a Site Visit
                </button>
              </div>
            </div>
          )}

        </div>
      </div>
    </div>
  );
}
